module.exports = __webpack_public_path__ + "static/media/VanillaRibbons.525af7d0.jpg";